import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { LogoSimpleIcon } from "../../../assets/icons/LogoSimpleIcon";

const SignupForm = ({ formData, handleChange, formErrors }) => {
  return (
    <div className="signup-box text-center mt-5">
      <LogoSimpleIcon />
      <h2 className="text-center">Créer un compte</h2>
      <p className="text-center">
        Créez votre espace sécurisé pour suivre vos simulations et projets
      </p>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="nom">
            <Form.Control
              name="nom"
              placeholder="Nom *"
              value={formData.nom}
              onChange={handleChange}
              isInvalid={!!formErrors.nom}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.nom}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="prenom">
            <Form.Control
              name="prenom"
              placeholder="Prénom *"
              value={formData.prenom}
              onChange={handleChange}
              isInvalid={!!formErrors.prenom}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.prenom}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="email">
            <Form.Control
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!formErrors.email}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.email}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="phone">
            <Form.Control
              name="phone"
              placeholder="Téléphone *"
              value={formData.phone}
              onChange={handleChange}
              isInvalid={!!formErrors.phone}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.phone}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="company">
            <Form.Control
              name="company"
              placeholder="Nom de la société *"
              value={formData.company}
              onChange={handleChange}
              isInvalid={!!formErrors.company}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.company}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="activitySector">
            <Form.Control
              name="activitySector"
              placeholder="Secteur d'activité *"
              value={formData.activitySector}
              onChange={handleChange}
              isInvalid={!!formErrors.activitySector}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.activitySector}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="KBIS1" className="d-none">
            <Form.Control
              type="hidden"
              name="KBIS1"
              value="Non Applicable"
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="SIRET">
            <Form.Control
              name="SIRET"
              placeholder="SIRET "
              value={formData.SIRET}
              onChange={handleChange}
              isInvalid={!!formErrors.SIRET}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.SIRET}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="SIREN">
            <Form.Control
              name="SIREN"
              placeholder="SIREN "
              value={formData.SIREN}
              onChange={handleChange}
              isInvalid={!!formErrors.SIREN}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.SIREN}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="ps-0">
          <Form.Group controlId="password">
            <Form.Control
              type="password"
              name="password"
              placeholder="Mot de passe *"
              value={formData.password}
              onChange={handleChange}
              isInvalid={!!formErrors.password}
              className="mb-2"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.password}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6} className="ps-0">
          <Form.Group controlId="confirmPassword">
            <Form.Control
              type="password"
              name="confirmPassword"
              placeholder="Répétez le mot de passe *"
              value={formData.confirmPassword}
              onChange={handleChange}
              isInvalid={!!formErrors.confirmPassword}
              className="mb-3"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.confirmPassword}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default SignupForm;
